import { gql } from 'urql';

/*
Note: The groupProfileAttributes query uses a limit of 1500 because that is the
maximum number of group attributes that listserv allows an account to create and the
groupProfileAttributes query requires that a limit is provided.
*/
export const GET_TARGETING_OPTIONS = gql`
  query GetTargetingOptions {
    banners: experiences(filter: { types: [BANNER] }) {
      id
      name
      steps {
        id
        name
      }
    }
    embeds: experiences(filter: { types: [EMBED] }) {
      id
      name
      steps {
        id
      }
    }
    checklists(filter: { states: [DRAFT] }) {
      id
      internalName
    }
    emails {
      id
      name
    }
    # Key Moments only. The unfiltered goals field returns every goal on the
    # account, and targeting reads nothing but v3 ones. The page limit is
    # required, since goalsV2 defaults to 10, and is set far above any
    # realistic Key Moment count.
    keyMoments: goalsV2(
      page: { limit: 500, offset: 0 }
      filter: { goalFormatVersion: 3 }
    ) {
      results {
        id
        name
        slug
        goalFormatVersion
        disabled
      }
    }
    flows(filter: { states: [DRAFT] }) {
      id
      name
      steps {
        stepType
        id
        index
      }
    }
    experienceFlows: experiences(filter: { types: [FLOW] }) {
      id
      name
      type
    }
    groupProfileAttributes(profileAttributesPage: { limit: 1500, offset: 0 }) {
      attributes {
        name
        label
      }
    }
    mobile: experiences(filter: { types: [MOBILE, MOBILE_EMBED] }) {
      id
      name
    }
    pins: experiences(filter: { types: [PERSISTENT] }) {
      id
      name
      steps {
        id
        name
      }
    }
    profileAttributes {
      name
      label
    }
    pushNotifications {
      id
      name
      content
    }
    segments {
      id
      name
    }
  }
`;
